import React, { useEffect, useRef } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18next from './Internationalization';
import { ThemeProvider } from 'styled-components';
import { theme } from './Theming';
import { Routes } from './Routing';
import { BrowserRouter as Router } from 'react-router-dom';
import { ModalProvider } from 'styled-react-modal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FeaturesProvider } from './PluginFeatures';
import TagManager from 'react-gtm-module';
import env from './env';

const App: React.FC = () => {
  const gtmInitialized = useRef(false);

  useEffect(() => {
    if (window.hyperise) {
      window.hyperise.init();
    }
    // to allow content switching for languages that read from right to left
    const dir = i18next.dir(i18next.language);
    document.documentElement.dir = dir;

    // Initialize GTM once env is available
    if (env?.gtm_id && !gtmInitialized.current) {
      TagManager.initialize({
        gtmId: env.gtm_id,
      });
      gtmInitialized.current = true;
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <FeaturesProvider>
        <I18nextProvider i18n={i18next}>
          <ModalProvider>
            <Router>
              <Routes />
              <ToastContainer position="bottom-right" />
            </Router>
          </ModalProvider>
        </I18nextProvider>
      </FeaturesProvider>
    </ThemeProvider>
  );
};

export default App;
